import { action as apiAction } from 'api/Api'
import {
  add,
  remove
} from 'store/redux/observedTags'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  cardId: number
  isObserved: boolean
}

const requestFollowCard = (payload: Payload) => async dispatch => {
  const { cardId, isObserved } = payload

  const tag = `card-${cardId}`

  let optimisticAction

  try {
    if (isObserved) {
      optimisticAction = optimisticDispatch(dispatch, add({
        tag,
      }))

      await apiAction('AddObservedTag', {
        name: tag
      })
    } else {
      optimisticAction = optimisticDispatch(dispatch, remove({
        tag,
      }))

      await apiAction('RemoveObservedTag', {
        name: tag
      })
    }

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    throw error
  }
}

export default requestFollowCard
